import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'

export const ScrollNavButtons = () => {
  const [showTop, setShowTop] = useState(false)
  const [showBottom, setShowBottom] = useState(false)

  const scrollFunction = () => {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = document.documentElement.clientHeight

    setShowTop(scrollTop > 300)
    setShowBottom(scrollTop + clientHeight < scrollHeight - 300)
  }

  useEffect(() => {
    scrollFunction()
    window.addEventListener('scroll', scrollFunction, { passive: true })

    return () => window.removeEventListener('scroll', scrollFunction)
  }, [])

  const topFunction = () => {
    document.body.scrollTop = 300
    document.documentElement.scrollTop = 300
  }

  const bottomFunction = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight })
  }

  if (!showTop && !showBottom) return null

  return (
    <>
      {showTop && (
        <div className="fixed right-[10px] bottom-[64px] z-20 sm:bottom-auto sm:top-[10px]">
          <button
            className="p-3 ring-[1px] hover-shadow1 ring-shade-blue bg-shade-blue text-white border hover:bg-white border-shade-blue hover:text-shade-blue rounded flex items-center gap-2"
            onClick={topFunction}
          >
            <ChevronUpIcon className="w-5 h-5"></ChevronUpIcon>
          </button>
        </div>
      )}
      {showBottom && (
        <div className="fixed right-[10px] bottom-[10px] z-20">
          <button
            className="p-3 ring-[1px] hover-shadow1 ring-shade-blue bg-shade-blue text-white border hover:bg-white border-shade-blue hover:text-shade-blue rounded flex items-center gap-2"
            onClick={bottomFunction}
          >
            <ChevronDownIcon className="w-5 h-5"></ChevronDownIcon>
          </button>
        </div>
      )}
    </>
  )
}
